module.exports = __webpack_public_path__ + "static/media/bannerBlackoutCorujao.dac1e1af.jpg";